var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('hr',{staticClass:"separate-line",style:(_vm.styleSeparateLine)})])
}
var staticRenderFns = []

export { render, staticRenderFns }